import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as c } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(c, { ...r, children: /* @__PURE__ */ o("path", { d: "m17.0734 15.8365-4.7598-4.7598c.6406-.8946 1.016-1.97685 1.016-3.15852 0-2.99282-2.4295-5.41137-5.41133-5.41137-2.99282 0-5.41137 2.42959-5.41137 5.41137 0 2.99282 2.42959 5.41142 5.41137 5.41142 1.18167 0 2.26393-.3755 3.15843-1.0161l4.7598 4.7598 1.2369-1.2368ZM4.16344 7.91818c0-2.0762 1.67863-3.75483 3.75483-3.75483s3.75483 1.67863 3.75483 3.75483S9.99447 11.673 7.91827 11.673 4.16344 9.98334 4.16344 7.91818Z" }) });
export {
  p as Search
};
//# sourceMappingURL=Search.js.map
